import packApi from "@/api/pack";
import serviceAreaApi from "@/api/serviceArea";

const actions = {
  async load({ commit }, packId) {
    commit("setLoading", true);
    try {
      const serviceAreaList = await packApi.serviceAreaSummary(packId);
      commit("update", serviceAreaList);
    } finally {
      commit("setLoading", false);
    }
  },
  async loadEdit({ commit }, serviceAreaId) {
    commit("setEdit", {});
    commit("setEditLoading", true);
    try {
      const response = await serviceAreaApi.get(serviceAreaId);
      const serviceArea = response.data.result;

      // Transform nested user objects to username strings for form binding
      const serviceAreaForEdit = {
        id: serviceArea.id,
        name: serviceArea.name,
        accountManager: serviceArea.accountManager?.username || null,
        careSetting: serviceArea.careSetting || null,
        contactPrimary: serviceArea.contactPrimary?.username || null,
        contactSecondary: serviceArea.contactSecondary?.username || null,
      };

      commit("setEdit", serviceAreaForEdit);
    } finally {
      commit("setEditLoading", false);
    }
  },
  async updateServiceArea({ dispatch }, { packId, serviceArea }) {
    await serviceAreaApi.update(serviceArea);
    await dispatch("load", packId);
  },
};

const mutations = {
  update(state, serviceAreaList) {
    state.list = serviceAreaList;
  },
  setLoading(state, isLoading) {
    state.loading = isLoading;
  },
  setEdit(state, serviceArea) {
    state.edit = serviceArea;
  },
  setEditLoading(state, isLoading) {
    state.editLoading = isLoading;
  },
};

const getters = {
  getMyList: state => username =>
    state.list.filter(serviceArea => {
      if (!serviceArea.accountManager) {
        return false;
      }

      return serviceArea.accountManager.username === username;
    }),
};

const state = {
  list: [],
  loading: false,
  edit: {},
  editLoading: false,
};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
};
